import { getAllAmbulancesApi, addNewAmbulanceApi, deleteAmbulanceApi, editAmbulanceApi } from "../../apis/ambulance";
import { getAllAmbulancesFailure, getAllAmbulancesSuccess,
  editAmbulanceFailure, editAmbulanceSuccess,
  deleteAmbulanceSuccess, deleteAmbulancesFailure,
  addNewAmbulanceSuccess,
  addNewAmbulanceFailure
 } from "../constants/ambulances";
 import { showNotification } from "./notification";

export function getAllAmbulanceSuccess(payload) {
  return { type: getAllAmbulancesSuccess, payload: payload}
}

export function getAllAmbulanceFail() {
  return { type: getAllAmbulancesFailure}
}

export function addNewAmbulanceDataSuccess(payload) {
  return { type: addNewAmbulanceSuccess, payload: payload}
}

export function addNewAmbulanceDataFail() {
  return { type: addNewAmbulanceFailure}
}

export function editAmbulanceDataSuccess(payload) {
  return { type: editAmbulanceSuccess, payload: payload}
}

export function editAmbulanceDataFail() {
  return { type: editAmbulanceFailure}
}

export function deleteAmbulanceDataSuccess(id) {
  return { type: deleteAmbulanceSuccess, payload: id}
}

export function deleteAmbulanceDataFail() {
  return { type: deleteAmbulancesFailure}
}

export function getAmbulanceList() {
  return ((dispatch) => {
    getAllAmbulancesApi().then(
      (res) => {
        dispatch(getAllAmbulanceSuccess(res))
      },
      (error) => {
        dispatch(getAllAmbulanceFail())
      }
    )
  });
}

export function addNewAmbulance(query) {
  return ((dispatch) => {
    addNewAmbulanceApi(query).then(
      (res) => {
        dispatch(addNewAmbulanceDataSuccess(res));
        dispatch(showNotification({
          type: "success",
          message: "Success",
          description: "New Ambulance Added Successfully"
        }))
      },
      (error) => {
        dispatch(addNewAmbulanceDataFail())
        dispatch(showNotification({
          type: "error",
          message: "Failed to Add",
          description: error?.message
        }))
      }
    )
  });
}

export function editAmbulance(id, query) {
  return ((dispatch) => {
    editAmbulanceApi(id, query).then(
      (res) => {
        dispatch(addNewAmbulanceDataSuccess(res))
        dispatch(showNotification({
          type: "success",
          message: "Success",
          description: "Ambulance Edited Successfully"
        }))
      },
      (error) => {
        dispatch(addNewAmbulanceDataFail())
      }
    )
  });
}

export function deleteAmbulance(id) {
  return ((dispatch) => {
    deleteAmbulanceApi(id).then(
      (res) => {
        dispatch(deleteAmbulanceDataSuccess(id));
        dispatch(showNotification({
          type: "success",
          message: "Success",
          description: "Ambulance Deleted Successfully"
        }))
      },
      (error) => {
        dispatch(deleteAmbulanceDataFail())
        dispatch(showNotification({
          type: "error",
          message: "Failed to Delete",
          description: error?.messsage
        }))
      }
    )
  });
}